import { render, staticRenderFns } from "./member_data.vue?vue&type=template&id=1b5a0373&scoped=true&"
import script from "./member_data.vue?vue&type=script&lang=ts&"
export * from "./member_data.vue?vue&type=script&lang=ts&"
import style0 from "./member_data.vue?vue&type=style&index=0&id=1b5a0373&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5a0373",
  null
  
)

export default component.exports